import { Injectable } from "@angular/core";

@Injectable()
export class TranslatorService {

    getCountryAdjective(countryCode: string): string {
        switch(countryCode) {
            case 'AU': {
                return 'Australian';
            }
            case 'AT': {
                return 'Austrian';
            }
            case 'BE': {
                return 'Belgian';
            }
            case 'CA': {
                return 'Canadian';
            }
            case 'EE': {
                return 'Estonian';
            }
            case 'DK': {
                return 'Danish';
            }
            case 'FI': {
                return 'Finnish';
            }
            case 'FR': {
                return 'French';
            }
            case 'DE': {
                return 'German';
            }
            case 'GR': {
                return 'Greek';
            }
            case 'HK': {
                return 'Hong Kong';
            }
            case 'IE': {
                return 'Irish';
            }
            case 'IT': {
                return 'Italian';
            }
            case 'IL': {
                return 'Israeli';
            }
            case 'LV': {
                return 'Latvian';
            }
            case 'LT': {
                return 'Lithuanian';
            }
            case 'LU': {
                return 'Luxembourgish';
            }
            case 'MX': {
                return 'Mexican';
            }
            case 'NL': {
                return 'Dutch';
            }
            case 'NZ': {
                return 'New Zealand';
            }
            case 'NO': {
                return 'Norwegian';
            }
            case 'PT': {
                return 'Portuguese';
            }
            case 'SG': {
                return 'Singaporean';
            }
            case 'SK': {
                return 'Slovakian';
            }
            case 'SI': {
                return 'Slovenian';
            }
            case 'ES': {
                return 'Spanish';
            }
            case 'SE': {
                return 'Swedish';
            }
            case 'CH': {
                return 'Swiss';
            }
            case 'GB': {
                return 'British';
            }
            case 'PE': {
                return 'Peruvian';
            }
            case 'US': {
                return 'American';
            }
            default: {
                return '';
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/translator/translator.service.ts